module.exports = __webpack_public_path__ + "img/icon-option-selected.f78d2874.svg";